<template lang="pug">
  v-container.px-10(fluid)
    h2.mt-5.white--text.display-1.font-weight-light.underline Bussiness Scopes
    v-row.mt-10
      v-col(cols="4", v-for="scope in scopes", :key="scope._uid")
        v-card(@click="selectScope(scope)")
          v-card-title {{ scope.name }}
</template>

<script>
import axios from 'axios'
import { uid, addGlobalWhere } from '@@/helpers'

export default {
  data: () => ({
    scopes: []
  }),
  methods: {
    selectScope (scope) {
      window.localStorage.setItem(ENV.SCOPE, scope.name)  
      this.$router.push({ name: 'entities.index' })
    },
    async load () {
      this.scopes = (await axios.get('BusinessScopes', { params: { pageSize: 300 } })).data.data
    }
  },
  mounted () {
    this.load()
  }
}
</script>
